module.exports = __webpack_public_path__ + "assets/img/3.65508824.png";